import { FC, useRef, useState } from 'react';

import { ActionList, Card, Checkbox, Divider, Flex } from '@hh.ru/magritte-ui';
import { EllipsisHorizontalOutlinedSize24 } from '@hh.ru/magritte-ui/icon';

import { useCampaignActionsMenuItems } from 'components/CampaignsDashboard/hooks/useCampaignActionsMenuItems';
import { useCampaignSelection } from 'components/CampaignsDashboard/hooks/useCampaignSelection';

import { CampaignActionsList } from 'components/CampaignsDashboard/components/CampaignsTable/components/CampaignActions/CampaignActionsList';

import { DashboardCampaign } from 'store/models/campaignsDashboard';

export const CampaignActions: FC<{
    campaign: DashboardCampaign;
    onToggleStatus: () => void;
    isStatusToggleLoading: boolean;
}> = ({ campaign, onToggleStatus, isStatusToggleLoading }) => {
    const { id: campaignId } = campaign;

    const [isMenuVisible, setIsMenuVisible] = useState(false);
    const activatorRef = useRef<HTMLButtonElement>(null);

    const { isSudo, actionsMenuItems, sudoActionsMenuItems, isMutatingActionAvailable } = useCampaignActionsMenuItems(
        campaign,
        onToggleStatus,
        isStatusToggleLoading
    );
    const { isChecked, isSelectionAvailable, onSelectionChange } = useCampaignSelection(
        campaign,
        isMutatingActionAvailable
    );

    const hideMenu = () => setIsMenuVisible(false);

    return (
        <Card padding={0} style="primary" borderRadius={8} borderWidth="default">
            {isSelectionAvailable && (
                <>
                    <Flex p={4}>
                        <Checkbox
                            checked={isChecked}
                            onChange={onSelectionChange}
                            data-qa={`campaign-checkbox-${campaignId}`}
                        />
                    </Flex>
                    <Divider />
                </>
            )}
            <EllipsisHorizontalOutlinedSize24
                ref={activatorRef}
                padding={4}
                initialColor="secondary"
                data-qa={`campaign-actions-ellipsis-${campaignId}`}
                onClick={() => setIsMenuVisible((prev) => !prev)}
            />
            <ActionList
                visible={isMenuVisible}
                onClose={hideMenu}
                dropProps={{ padding: 12, placement: 'bottom-end', activatorRef }}
            >
                <CampaignActionsList
                    campaignId={campaignId}
                    actionsMenuItems={actionsMenuItems}
                    sudoActionsMenuItems={sudoActionsMenuItems}
                    isSudo={isSudo}
                    dataQaPrefix="campaign-action"
                    onAction={hideMenu}
                />
            </ActionList>
        </Card>
    );
};
